/// <reference path="emoji_data.ts" />

import {ASCII2, EMOJI, EMOJI_NAMES} from "./emoji_data";
export class EmojiConverter
{
	// Regexes that we use to find patterns (unicode emojis, names, ascii emoticons)
	// in the text
	private emojiRegExp        : RegExp;
	private asciiToNameRegex   : RegExp;
	private nameToUnicodeRegex : RegExp;

	private fromPath = true;

	/**
	 * Escapes a string so that it can be used in regexes
	 */
	static escapeRegex(str : string)
	{
		return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
	}

	constructor(private image : string)
	{
		// Create regex objects based on the input data.
		// TODO: This could be optimized to be done at compile time.

		// Ascii to names conversation.
		// TODO: This can be optimized to convert ascii directly into unicode.

		var asciiSmileys = [];
		for(let name in ASCII2) {
			if (ASCII2.hasOwnProperty(name)) {
				for(let i=0; i < ASCII2[name].length; i++) {
					asciiSmileys.push(EmojiConverter.escapeRegex(ASCII2[name][i]));
				}
			}
		}

		this.asciiToNameRegex = new RegExp("(" + asciiSmileys.join('|') + ")", "gi");

		var emojiSamples = [];
		for(var k in EMOJI) emojiSamples.push(this.ca(k))
		this.emojiRegExp = new RegExp('(' + emojiSamples.join('|') + ')', 'gi');

		var names = [];
		for (var i=0; i<EMOJI_NAMES.length; i++) {
			var name = ":" + EMOJI_NAMES[i][1] + ":";
			if (names.indexOf(name) == -1) names.push(name);
		}

		this.nameToUnicodeRegex = new RegExp("(" + names.join('|') + ")", "gi");
	}

	ca (r)
	{
		let t, n;
		for (t = "", n = 0; n < r.length; n++) {
			t += "\\u" + ("000" + r[n].charCodeAt(0).toString(16)).substr(-4);
		}
		return t;
	}

	cp(t) {
		for (var n = [], r = 0, o = 0, h = 0; h < t.length;)
			r = t.charCodeAt(h++),
				o ? (n.push((65536 + (o - 55296 << 10) + (r - 56320)).toString(16)), o = 0)
					: r >= 55296 && 56319 >= r ? o = r : n.push(r.toString(16));
		return n.join("-")
	}

	unicodeToImage(text : string, extra = false)
	{
		return text.replace(this.emojiRegExp, (a, b) =>
		{
			var image = this.image + this.cp(b.replace(/\ufe0f|\u200d/gm, ''))+'.svg';
			return "<span class=\"sxc-emoji " + (extra ? "sxc-emoji-40" : "") + "\" data-sxc-u=\"" + b + "\" style=\"background-image: url(" + image + ");\">" + b + "</span>"
		});
	}

	imageToUnicode(html) {

		var $html = $("<div/>").html(html);

		var $spans = $html.find("span.sxc-emoji");

		$spans.each((i, span) => {
			var $span = $(span);
			$span.replaceWith($span.data("sxc-u"));
		});

		return $html.html();
	}

	unicodeToName(str : string)
	{
		for (var i=0; i<EMOJI_NAMES.length; i++) {
			var name = ":" + EMOJI_NAMES[i][1] + ":";
			var chars = EMOJI_NAMES[i][0];
			str = str.split(chars).join(name)
		}

		return str;
	}

	asciiToName(str)
	{
		str = str.replace(this.asciiToNameRegex, (a, b) => {
			for (var name in ASCII2) {
				if (ASCII2.hasOwnProperty(name)) {
					for (var i=0; i< ASCII2[name].length; i++) {
						if (b.toUpperCase() === ASCII2[name][i].toUpperCase()) return name;
					}
				}
			}
		});

		return str;
	}

	nameToAscii(str)
	{
		for (var name in ASCII2) {
			if (ASCII2.hasOwnProperty(name)) {
				str = str.split(name).join(ASCII2[name][0])
			}
		}
		return str;
	}

	nameToUnicode(str)
	{
		str = str.replace(this.nameToUnicodeRegex, (a, b) => {

			for (let i = 0; i < EMOJI_NAMES.length; i++)
			{
				const name = ":" + EMOJI_NAMES[i][1] + ":";
				if (b == name) {
					return EMOJI_NAMES[i][0];
				}
			}
		});

		return str;
	}

	/**
	 * Converts ascii emoticons and emoji names in a string to their proper unicode character
	 *
	 * @param str
	 * @returns {string}
	 */
	asciiToUnicode(str : string)
	{
		// We have to convert names first so parts of names wouldn't be converted from ascii to names
		str = this.nameToUnicode(str);
		str = this.asciiToName(str);
		str = this.nameToUnicode(str);
		return str;
	}

	/**
	 * Converts all unicode emojis from the specified string to their ascii representation.
	 * If there is no ascii equivalent for an emoticon we just use their names.
	 *
	 * @param str
	 * @returns {string}
	 */
	unicodeToAscii(str : string) : string
	{
		str = this.unicodeToName(str);
		str = this.nameToAscii(str);
		return str;
	}
}
